import React from 'react';
import { SAMPLE_LOAD, SAMPLE_STOPS } from './samples';

const ImportCompletePreview = () => (
  <div className="dp-page">
    <div className="dp-stepper">
      <span className="dp-stepper__step dp-stepper__step--done">Upload</span>
      <span className="dp-stepper__line dp-stepper__line--done" />
      <span className="dp-stepper__step dp-stepper__step--done">Review</span>
      <span className="dp-stepper__line dp-stepper__line--done" />
      <span className="dp-stepper__step dp-stepper__step--active">Complete</span>
    </div>

    <div className="dp-success-hero">
      <div className="dp-success-hero__icon" aria-hidden="true">
        ✓
      </div>
      <div>
        <h1 className="dp-title">Import complete</h1>
        <p className="dp-lead">
          Freight <strong>{SAMPLE_LOAD.freight_number}</strong> is ready. One manifest and a
          route plan draft were created with <strong>2 stops</strong> on the plan.
        </p>
      </div>
    </div>

    <div className="dp-success-grid">
      <section className="dp-panel dp-panel--highlight">
        <h2 className="dp-panel__title">Route plan stops</h2>
        <ul className="dp-stop-list">
          {SAMPLE_STOPS.map((stop) => (
            <li key={stop.sequence} className={`dp-stop-list__item dp-stop-list__item--${stop.type}`}>
              <span className="dp-stop-list__seq">{stop.sequence}</span>
              <div>
                <div className="dp-stop-list__label">{stop.label}</div>
                <div className="dp-stop-list__addr">{stop.address}</div>
              </div>
              <span className={`dp-badge dp-badge--${stop.type}`}>{stop.type}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="dp-panel">
        <h2 className="dp-panel__title">What was created</h2>
        <dl className="dp-dl">
          <dt>Freight</dt>
          <dd>{SAMPLE_LOAD.freight_number}</dd>
          <dt>Manifests</dt>
          <dd>1 delivery manifest</dd>
          <dt>Route plan</dt>
          <dd>Draft · Chattanooga Depot → MI → NC</dd>
          <dt>Broker</dt>
          <dd>{SAMPLE_LOAD.broker_name}</dd>
        </dl>

        <div className="dp-callout dp-callout--info">
          <strong>Tip for demos</strong>
          <p>
            Open the route planner from this screen so stakeholders see the full TN → MI → NC path
            on the map.
          </p>
        </div>
      </section>
    </div>

    <div className="dp-action-bar dp-action-bar--center">
      <button type="button" className="dp-btn dp-btn--ghost">
        Import another PDF
      </button>
      <button type="button" className="dp-btn dp-btn--secondary">
        View freight
      </button>
      <button type="button" className="dp-btn dp-btn--primary">
        Open route planner
      </button>
    </div>
  </div>
);

export default ImportCompletePreview;
